import type { SpeechPlayer } from './contracts';
import type { BargeIn } from './barge-in';

/** Local 20 ms windows arrive ahead of the 100 ms wire frame. */
export function createCapturedOnset(
  player: SpeechPlayer | undefined,
  barge: BargeIn,
  now: () => number,
) {
  let epoch: number | null = null;
  return (rms: number, samples?: Float32Array, sampleOffset?: number) => {
    if (!samples || sampleOffset === undefined || !player?.echoLevel) {
      barge.frame(rms);
      return;
    }
    epoch ??= now() - sampleOffset / 16;
    // The worklet sample clock remains ordered even when callbacks are batched.
    const at = epoch + sampleOffset / 16;
    const state = player.state();
    if (state !== 'speaking' && state !== 'loading') return;
    const pcm = Int16Array.from(samples, (value) =>
      Math.max(-32768, Math.min(32767, Math.round(value * 32768))),
    );
    barge.frame(rms, player.echoLevel(pcm, 16000, Math.max(0, now() - at)), at);
  };
}
